import { render, staticRenderFns } from "./CostCorrectSpf.vue?vue&type=template&id=6a89d35a&scoped=true&"
import script from "./CostCorrectSpf.vue?vue&type=script&lang=ts&"
export * from "./CostCorrectSpf.vue?vue&type=script&lang=ts&"
import style0 from "./CostCorrectSpf.vue?vue&type=style&index=0&id=6a89d35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89d35a",
  null
  
)

export default component.exports